module.exports = __webpack_public_path__ + "static/img/sybanner-2.6c4d7b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sybanner-2.png
// module id = T/cj
// module chunks = 0